import {Box, Typography} from "@material-ui/core";
import {useStyles} from "./styles";

const assessmentTypeLabels = {
    online: 'Online',
    printed: 'Impressa',
};

export function BoxDetails({
    availabilityName,
    className,
    questionAmount,
    start,
    end,
    durationInMinutes,
    assessmentType
}) {
    const classes = useStyles();
    const isPrinted = assessmentType === 'printed';
    return (
        <div  style={{padding: 20, borderRadius: 5, backgroundColor: '#373737', marginBottom: 10}}>
            <Typography variant="h5" className={classes.pageTitle}>
                {availabilityName}
            </Typography>

            <Box className={classes.infoRow}>
                <Box className={classes.infoItem}>
                    <Typography variant="caption" className={classes.infoLabel}>Turma</Typography>
                    <Typography variant="body2" className={classes.infoValue}>{className}</Typography>
                </Box>
                <Box className={classes.infoItem}>
                    <Typography variant="caption" className={classes.infoLabel}>Qtd. de Questões</Typography>
                    <Typography variant="body2" className={classes.infoValue}>{questionAmount}</Typography>
                </Box>
                {!isPrinted && (
                    <>
                        <Box className={classes.infoItem}>
                            <Typography variant="caption" className={classes.infoLabel}>Data de Início</Typography>
                            <Typography variant="body2" className={classes.infoValue}>{start}</Typography>
                        </Box>
                        <Box className={classes.infoItem}>
                            <Typography variant="caption" className={classes.infoLabel}>Data de Fim</Typography>
                            <Typography variant="body2" className={classes.infoValue}>{end}</Typography>
                        </Box>
                        <Box className={classes.infoItem}>
                            <Typography variant="caption" className={classes.infoLabel}>Tempo de Avaliação</Typography>
                            <Typography variant="body2" className={classes.infoValue}>{durationInMinutes} minutos</Typography>
                        </Box>
                    </>
                )}
                <Box className={classes.infoItem}>
                    <Typography variant="caption" className={classes.infoLabel}>Tipo de Avaliação</Typography>
                    <Typography variant="body2" className={classes.infoValue}>{assessmentTypeLabels[assessmentType]}</Typography>
                </Box>
            </Box>

        </div>
    )
}